import { Caption, H3 } from '~/shared/Typography';
import { HStack, Box, Pressable } from 'native-base';
import { Plan, resizedUrl, useTheme } from '@springbig/shared';
import { useAppNavigate } from '~/pages';
import PlanBenefits from '~/pages/subscriptions/components/PlanBenefits';
import { PlanSchedule } from '~/pages/subscriptions/components/PlanSchedule';
import React from 'react';
import { Card, Button } from '~/shared/Theme';

type PlanCardProps = {
    plan: Plan;
    status: 'active' | 'inactive';
};

const PlanCard = ({ plan, status }: PlanCardProps) => {

    const { navigate, params } = useAppNavigate();

    const {
        primary,
        card_border_size,
        button_text,
    } = useTheme();

    const onClickPlan = (): void => {

        const id = plan.id?.split('-').slice(1, -1).join('-');
        const idPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

        if (params.wallet_id && idPattern.test(id)) {
            navigate(`w/${params.wallet_id}/subscription/${id}`);
        }
    };

    return (
        <Card
            p={plan.plan_description_type === 'bullet' ? 4 : 0}
            space={2}
            borderWidth={plan.plan_description_type === 'bullet' ? card_border_size : 0}
        >
            { plan.plan_description_type === 'bullet' &&
                <H3
                    color={primary}
                    textAlign={'center'}
                    fontSize={24}
                >
                    { plan.name }
                </H3>
            }

            { plan.plan_description_type === 'image' ?

                <Pressable
                    onPress={onClickPlan}
                >
                    <img src={resizedUrl(plan?.plan_description_image?.thumbnailSrc, 9999, 480, 'inside')} width={'100%'} loading='lazy' />
                </Pressable>

                :

                <HStack justifyContent={'space-between'} space={2}>

                    <PlanBenefits plan={plan} />

                    <Button
                        alignSelf={'center'}
                        onPress={onClickPlan}
                        px={4}
                        justifyContent={'center'}
                    >
                        { plan.subscription?.status === 'suspended' &&
                            <Box borderRadius={'100%'} h={3} w={3} position={'absolute'} bg={'red'} right={-20} top={-14} />
                        }
                        <Caption
                            color={button_text}
                            text={status === 'active' ? 'subscriptions.enjoying' : 'subscriptions.get'}
                        />
                    </Button>
                </HStack>
            }

            { plan.plan_description_type === 'bullet' &&
                <PlanSchedule plan={plan} />
            }
        </Card>
    );
};

export default PlanCard;
